import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from "react-router-dom";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import "./styles/main.css"
import "./styles/media_1600.css"
import "./styles/media_1100.css"
import "./styles/media_800.css"
import Cookies from "js-cookie";
import getUrl from "./requests/getUrl";
import NotFound from "./pages/Errors/NotFound";
import {generateKey} from "./business/crypto/encode";
// Fonts 

import "./fonts/Inter/Inter-Regular.otf"
import "./fonts/Inter/Inter-SemiBold.otf"
import "./fonts/Inter/Inter-Medium.otf"

function App() {
    const navigate = useNavigate();


    const isSessionValid = async () => {
        const expires = await fetchSessionExpiry();
        console.log("expires: ", expires);

        if (!expires) {
            console.log("Session expired");
            return false;
        }

        const expiresDate = new Date(expires);

        const nowGMT = new Date();

        console.log("expires GMT: ", expiresDate.toUTCString(), "; Now GMT: ", nowGMT.toUTCString());

        return expiresDate > nowGMT;
    };

    const fetchSessionExpiry = async () => {
        try {
            const res = await fetch(getUrl()+"/api/login/session/expiry", {
                method: "GET",
                credentials: "include",
            });
            if (res.status == 401) {
                return false
            }
            if (!res.ok) {
                throw new Error(`Error fetching session expiry: ${res.status}`);
            }

            const data = await res.json();
            return data.expires_by
        } catch (err) {
            console.error("Failed to fetch session expiry", err);
        }
    };

    function deleteSessionCookies() {
        const cookiesToRemove = ["SESSIONID", "SESSION_EXPIRES"]; 

        cookiesToRemove.forEach(cookieName => {
            Cookies.remove(cookieName); 
        });
    }

    useEffect(() => {
        async function checkSessionExpiry() {
            let sessionValid = await isSessionValid()
            console.log("sessionValid: ", sessionValid)
            if (!sessionValid) {

                deleteSessionCookies()
                navigate("/login");
            }
        }
        checkSessionExpiry()

    }, [navigate]);

    return (
        <Routes>
            <Route path="/home" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/home" />} />
            <Route path="*" element={<NotFound/>}/>
        </Routes>
    );
}

export default function WrappedApp() {
    return (
        <Router>
            <App />
        </Router>
    );
}
